import ContactUs from "../../../pages/ContactUs.jsx"

const Helpline = () => {
  return (
    <div className="">
     <ContactUs/>
    </div>
  );
};
export default Helpline;
